export default __webpack_public_path__ + "static/media/featureCourse.2ff102e1.JPG";